import {
  Home,
  Cloud,
  Bot,
  Settings,
  PlusCircle,
  Users,
  BarChart3,
  Mail,
  Shield,
  LogOut,
  Server,
  ListChecks,
  FlaskConical,
  ClipboardList,
} from "lucide-react";

export const navigationConfig = [
  {
    type: "link",
    to: "/home",
    icon: Home,
    label: "Home",
  },
  {
    type: "link",
    to: "/accounts",
    icon: Cloud,
    label: "Manage Public Cloud Accounts",
  },
  {
    type: "separator",
    label: "AI Agents",
  },
  {
    type: "dropdown",
    icon: Bot,
    label: "Agents",
    items: [
      {
        to: "/aws/agents/healthops",
        icon: Bot,
        label: "HealthOps",
      },
    ],
  },
  {
    type: "separator",
    label: "Cloud Providers",
  },
  {
    type: "dropdown",
    icon: "aws-logo",
    iconType: "image",
    isWhite: true,
    label: "AWS",
    items: [
      {
        to: "/aws/agents",
        icon: Settings,
        label: "Agents",
      },
      {
        to: "/aws/create-account",
        icon: PlusCircle,
        label: "Create Account",
      },
      {
        to: "/aws/user-management",
        icon: Users,
        label: "User Management",
      },
      {
        to: "/aws/permission-sets",
        icon: Shield,
        label: "Manage Permissions",
      },
      {
        to: "/aws/reports",
        icon: BarChart3,
        label: "Reports",
      },
    ],
  },
  {
    type: "dropdown",
    icon: Server,
    label: "AWS LCCS",
    items: [
      {
        to: "/outposts",
        icon: Server,
        label: "Capacity Management",
      },
      {
        to: "/capacity-tasks",
        icon: ListChecks,
        label: "Capacity Tasks",
      },
      {
        to: "/outposts/sandbox",
        icon: FlaskConical,
        label: "Sandbox",
      },
      {
        to: "/outposts/settings",
        icon: ClipboardList,
        label: "Outpost Registry",
      },
    ],
  },
  {
    type: "dropdown",
    icon: "azure-logo",
    iconType: "image",
    isWhite: true,
    label: "Azure",
    items: [
      {
        to: "/azure/reports",
        icon: BarChart3,
        label: "Reports",
      },
    ],
  },
  {
    type: "dropdown",
    icon: "gcp-logo",
    iconType: "image",
    isWhite: true,
    label: "GCP",
    items: [
      {
        to: "/gcp/reports",
        icon: BarChart3,
        label: "Reports",
      },
    ],
  },
  {
    type: "dropdown",
    icon: "oci-logo",
    iconType: "image",
    isWhite: true,
    label: "OCI",
    items: [
      {
        to: "/oci/reports",
        icon: BarChart3,
        label: "Reports",
      },
    ],
  },
  {
    type: "separator",
    label: "Tools",
  },
  {
    type: "link",
    to: "/email/bulk",
    icon: Mail,
    label: "Bulk Email",
  },
  {
    type: "link",
    to: "/wiz",
    icon: Shield,
    label: "Wiz Reports",
  },
];

export const footerNavigationConfig = [
  {
    type: "logout",
    to: "/login",
    icon: LogOut,
    label: "Sign Out",
    isLogout: true,
  },
];
